// "use strict"

import { get, drop, dropRight, mapValues } from 'lodash'
import fetch from 'node-fetch'
import co from 'co'
import { cssClasses as useClass } from 'appxigon-common'
import { andList } from 'prelude-ls'

// e.g.
// normalizeSchemaKey('this.property-type')
// ===
// 'landing.info-and-options.property-type'
// where 'landing' is view ID and 'info-and-options' is group ID
export function normalizeSchemaKey(keyRef, keyOfCurrentEntity) {
  var normalizedKey = keyRef // default
  if (keyRef.split('.')[0] === 'this') {
    normalizedKey =
      dropRight(keyOfCurrentEntity.split('.')) // parent
      .concat(drop(keyRef.split('.'))) // append self (with 'this' removed)
      .join('.')
  }
  // console.info(`keyRef / normalizedKey: ${keyRef} / ${normalizedKey}`)
  return normalizedKey
}

export function getAuthToken() {
  return localStorage.getItem('Appxigon.token')
}

export function getAuthTokenExpiry() {
  return localStorage.getItem('Appxigon.token-expiry')
}

// FIXME: non-naive user validity check
export function validUserLogin() {
  const conditions = {
    userid: (id) => id && id != 'null',
    token: (token) => token && token != 'null',
    'token-expiry': (expiry) => expiry && expiry != 'null' && expiry > Date.now(),
    'user-error': (e) => e == '' || e != 'unauthorized-user',
  }
  const results = Object.keys(conditions)
                    .map((c) => {
                      var val = localStorage.getItem(`Appxigon.${c}`)
                      // console.log(`_ validUserLogin: key / val / check: ${c} / ${val} / ${conditions[c](val)}`)
                      return conditions[c](val)
                    })
  // console.info(`___ validate Login results: ${JSON.stringify(results)}`)
  return andList(results)
}

// export function* createFetcher(url) {
//   const response = yield fetch(url)
//   return yield response.json()
//   // return yield (yield fetch(url)).json()
// }
//
// export function fetchFrom(url) {
//   return co(createFetcher(url))
// }

export function getCurrentRouteId() {
  let history = get(window, 'appxigon.history')
  return history
          ? history.getCurrentLocation().pathname.replace('/', '')
          : null
}

// valMap: usually the state store. e.g. store.AXGState
// transform: e.g. {"matrixName": "$chart.matrix-name"}
export function transformUrl(url, transform, valMap) {
  const kvReplaceToken = ['{', '}']
  let keyMap = transform
  let keyMapTransformed =
    mapValues(
      keyMap,
      (val) => {
        return get(valMap, val)
      }
    )
  return kvReplace(
    url,
    keyMapTransformed,
    kvReplaceToken
  )
}

// turn POST style request-map (JSON object) to query strings for GET
/*
  e.g.
    request-map:
      locale: $chart.locale
      plan_selection: $chart.plan-selection
  is transformed as:
    locale={valueMap['$chart.locale']}&plan_selection={valueMap['$chart.plan-selection']}
*/
export function requestMapToQueryString(requestMap, valMap) {
  let transformedMap = mapValues(
    requestMap,
    (val) => typeof val == 'string'
              ? get(valMap, val, val)
              : val // in case the map value is not a string TODO: deeper mapping
  )
  return Object.keys(transformedMap)
          .map((k) =>
            `${k}=${
              typeof transformedMap[k] == 'string'
                ? transformedMap[k]
                : JSON.stringify(transformedMap[k])
            }`
          )
          .join('&')
}

export function _t(key, locale) {
  let i18n = get(window, 'i18n')
  if (i18n) {
    locale = locale || get(i18n, 'default', locale)
    return i18n && get(i18n, `${locale}.${key}`, key)
  } else {
    return key
  }
}

export function kvReplace(str, data, delimiter = [ '{{ ', ' }}' ]) {
	Object.keys(data).forEach((key, i) => {
		const regexp = new RegExp(delimiter[0] + key + delimiter[1], 'g')
		const value  = typeof data[key]==='function' ? data[key](key, i, data, str) : data[key]

		str = str.replace(regexp, value)
	})
	return str
}

// export const isSigninView = (document.URL.split('/').pop() == 'signin')

export { useClass }



// WEBPACK FOOTER //
// ./lib/utils.js